import alert from "@/mixin/alert.mixin";
import router from "@/router/index";
import StudentStatuses from "@/utils/constants/student/studentStatuses";

export default {
  //TODO: Change because don't save in store information to pass another view
  setProvisionalRemedyRequestRef(context, ProvisionalRemedyRequestRef) {
    let vm = this;
    vm.commit("setProvisionalRemedyRequestRef", ProvisionalRemedyRequestRef);
  },
  setProvisionalRemedyRequest(context, ProvisionalRemedyRequest) {
    context.commit("setProvisionalRemedyRequest", ProvisionalRemedyRequest);
  },
  //END TODO
  setSelectedPei(context, pei) {
    let vm = this;
    sessionStorage.setItem("peiSelected", JSON.stringify(pei));
    vm.commit("setSelectedPei", pei);
  },
  setATServiceAmmendment(context, atServiceAmmendment) {
    let vm = this;
    sessionStorage.setItem("peiATAmmendment", atServiceAmmendment);
    vm.commit("setATServiceAmmendment", atServiceAmmendment);
  },
  setSelectedPlacementCommitte(context, placementCommittee) {
    let vm = this;
    vm.commit("setSelectedPlacementCommitte", placementCommittee);
  },
  setSelectedPeiStatus(context, peiStatus) {
    const vm = this;
    vm.commit("setSelectedPeiStatus", peiStatus);
  },
  setSelectedPeiStatusDescription(context, peiStatus) {
    const vm = this;
    vm.commit("setSelectedPeiStatusDescription", peiStatus);
  },
  setSelectedSignatureParticipant(context, singatureParticipant) {
    const vm = this;
    vm.commit("setSelectedSignatureParticipant", singatureParticipant);
  },
  setSelectedPeiEvaluationDateId(context, evaluationDateId) {
    const vm = this;
    vm.commit("setSelectedPeiEvaluationDateId", evaluationDateId);
  },
  setSelectedPeiConfigUnilateralFlag(context, configUnilateralFlag) {
    const vm = this;
    vm.commit("setSelectedPeiConfigUnilateralFlag", configUnilateralFlag);
  },
  setSelectedPeiConfigExtendedSchoolYearFlag({ commit }, configUnilateralFlag) {
    commit("setSelectedPeiConfigExtendedSchoolYearFlag", configUnilateralFlag);
  },
  setSelectedPeiConfigOtherServTechAssistEquipFlag(
    { commit },
    configUnilateralFlag
  ) {
    commit(
      "setSelectedPeiConfigOtherServTechAssistEquipFlag",
      configUnilateralFlag
    );
  },
  setSelectedEvidenceReportParams(context, rlvEvidenceReportParams) {
    const vm = this;
    vm.commit("setSelectedEvidenceReportParams", rlvEvidenceReportParams);
  },
  setSelectedPeiAcademicYearId({ commit }, configAcademicYearId) {
    commit("setSelectedPeiAcademicYearId", configAcademicYearId);
  },
  setSelectedPeiLocationRejected(context, peiLocationRejected) {
    const vm = this;
    vm.commit("setSelectedPeiLocationRejected", peiLocationRejected);
  },
  setSelectedPeiInfo(context, peiInfo) {
    const vm = this;
    vm.commit("setSelectedPeiInfo", peiInfo);
  },
  setPeiHasAcademicAreas(context, hasAA) {
    const vm = this;
    vm.commit("setPeiHasAcademicAreas", hasAA);
  },
  setPeiHasAlternativeAcademicUbications(context, hasAAU) {
    const vm = this;
    vm.commit("setPeiHasAlternativeAcademicUbications", hasAAU);
  },
  setPreviousPeiId(context, previousPeiId) {
    const vm = this;
    vm.commit("setPreviousPeiId", previousPeiId);
  },
  setPeiControversies(context, controversies) {
    const vm = this;
    vm.commit("setPeiControversies", controversies);
  },
  // End PEI
  setSelectedAt(context, id) {
    let vm = this;
    sessionStorage.setItem("atSelected", JSON.stringify(id));
    vm.commit("setSelectedAt", id);
  },

  setActiveATTab(context, tab) {
    let vm = this;
    vm.commit("setActiveATTab", tab);
  },
  setSelectPreEvalAnswer(context, id) {
    let vm = this;
    vm.commit("setSelectPreEvalAnswer", id);
  },
  setSelectRecentlyEvalBy(context, id) {
    let vm = this;
    vm.commit("setSelectRecentlyEvalBy", id);
  },
  setAtValidationTriggered(context, item) {
    let vm = this;
    vm.commit("setAtValidationTriggered", item);
  },
  setAtCompleted(context, value) {
    let vm = this;
    vm.commit("setAtCompleted", value);
  },
  saveChangeStudent() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.state.studentSave();
        resolve();
      } catch {
        reject();
      }
    });
  },
  saveChangesOnForm() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.state.tab.saveMethod();
        this.commit("setFormDirty", { value: false });
        resolve();
      } catch {
        // this try catch is because while saving if an error occurred
        // it mustn't reset FormDirty, because the user must known
        // it coulnd't be saved correctly.
        reject();
      }
    });
  },
  ChangeInitialEvaluationAction() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.state.tab.changeInitEvaluationMethod();
        resolve();
      } catch {
        reject();
      }
    });
  },
  AfterConfirmAppoinmentAction() {
    return new Promise(async (resolve, reject) => {
      try {
        await this.state.afterConfirmAppoinmentMethod();
        resolve();
      } catch {
        reject();
      }
    });
  },
  canChangeStudent({ dispatch }) {
    return new Promise(async resolve => {
      let canLeave = true;
      try {
        const response = await alert.methods.ShowCancelModal(
          "Atención",
          "El sistema detectó que se cambió el estudiante, usted será redireccionado al menú principal. ¿Está seguro que desea continuar?",
          "Sí",
          "No"
        );
        if (response) {
          await dispatch("saveChangeStudent");
        } else {
          this.state.resetStudent();
        }
        resolve(canLeave);
      } catch {
        canLeave = false;
        resolve(canLeave);
      }
    });
  },
  canLeavePage({ dispatch }) {
    return new Promise(async resolve => {
      let canLeave = true;
      try {
        if (this.state.tab.currentFormDirty) {
          const response = await alert.methods.ShowCancelModal(
            "Atención",
            "El sistema encontró que tiene datos sin guardar en esta parte, ¿desea guardar la información antes de continuar?",
            "Sí",
            "No"
          );
          if (response) {
            await dispatch("saveChangesOnForm");
          } else {
            this.state.tab.resetOriginalDataMethod();
          }
          resolve(canLeave);
        } else {
          resolve(canLeave);
        }
      } catch {
        canLeave = false;
        resolve(canLeave);
      }
    });
  },
  // Set Affirmative Letter
  setSelectedPeiAffirmativeLetter(context, peiAffirmativeLetter) {
    const vm = this;
    vm.commit("setSelectedPeiAffirmativeLetter", peiAffirmativeLetter);
  },

  setPeiValidationTriggered(context, item) {
    let vm = this;
    vm.commit("setPeiValidationTriggered", item);
  },
  // Set Pei Analisys Service
  setAnalysisServiceId(context, item) {
    let vm = this;
    vm.commit("setAnalysisServiceId", item);
  },
  setPeiTransportationInfo(context, transportationInfo) {
    const vm = this;
    vm.commit("setPeiTransportationInfo", transportationInfo);
  },
  setParentRouter(context, newRouter) {
    if (
      !context.state.parentsRouter.some(elem => elem.name == newRouter.name)
    ) {
      context.commit("setParentRouter", newRouter);
    }
  },
  RedirectRouter(context, currentRouter) {
    let parents = context.state.parentsRouter;
    if (parents) {
      let routePath = currentRouter.path;
      parents.map(val => {
        // Avoided redundant navigation to current location
        if (routePath != val.path) {
          if (routePath.includes(val.path)) {
            router.push({ name: val.name });
          }
        }
      });
    }
  },
  setPeiTab2Information(context, newValue) {
    context.commit("setPeiTab2Information", newValue);
  },
  setVisiblePeiSignSection(context, newValue) {
    context.commit("setVisiblePeiSignSection", newValue);
  },
  setExit(context, newValue) {
    context.commit("setExit", newValue);
  },
  setRegister(context, newValue) {
    context.commit("setRegister", newValue);
  },
  setRegisterEvaluation(context, newValue) {
    context.commit("setRegisterEvaluation", newValue);
  },
  validateStudentSelection(context, args) {
    let student = args.student;
    let success = args.success;
    let error = args.error;

    let selectedStudentMustHaveRegistration =
      context.store.getters.SelectedStudentMustHaveRegistration;

    let regIsValid =
      !selectedStudentMustHaveRegistration ||
      (selectedStudentMustHaveRegistration &&
        student.statusId != null &&
        student.statusId != StudentStatuses.Disponible);

    if (regIsValid) {
      if (success != undefined) {
        success();
      }
    } else {
      let errorMessage = null;

      if (!regIsValid)
        errorMessage =
          "El estudiante no cuenta con un registro para el programa de Educación Especial.";
      else errorMessage = "Error validando usuario seleccionado.";

      if (error != undefined) {
        error(errorMessage);
      }
    }
  },
  async registerStudent() {
    await this.state.tab.registerMethod();
  }
};
